import type React from "react"
import { useTranslation } from "react-i18next"

import { Page } from "@/components/page"
import { SigmaReport } from "@/components/sigma-report"
import {
  SigmaWorkbookId,
  allQAWorkspaceName,
  useSigmaWorkbooks,
} from "@/services/sigma"
import type { SigmaWorkbook } from "@/services/sigma"

export const DataQARoute: React.FC = () => {
  const { t } = useTranslation("data")
  const { sigmaWorkbooksData } = useSigmaWorkbooks({
    apiOptions: {
      workspaceNames: [allQAWorkspaceName],
    },
  })

  const dataCompletenessWorkbook: SigmaWorkbook | undefined =
    sigmaWorkbooksData?.entries.find(
      (workbook) =>
        (workbook.workbookId as SigmaWorkbookId) ===
        SigmaWorkbookId.DataCompleteness
    )

  return (
    <Page fullHeight>
      <SigmaReport
        reportTitle={t("tab.qa")}
        workbookId={dataCompletenessWorkbook?.workbookId}
      />
    </Page>
  )
}
